import React from 'react';
import { Badge } from '@/components/ui/badge';
import { MiniApp } from '@/types/miniApp';

interface MiniAppIconProps {
  app: MiniApp;
  hasValidSession?: boolean;
  onClick: () => void;
}

export const MiniAppIcon: React.FC<MiniAppIconProps> = ({ app, hasValidSession, onClick }) => {
  const getStatusBadge = () => {
    if (!app.requiresAuth) {
      return (
        <Badge variant="outline" className="absolute -top-1 -right-1 scale-75 bg-primary/20 text-primary border-primary/30">
          •
        </Badge>
      );
    }
    
    if (hasValidSession) {
      return (
        <Badge variant="success" className="absolute -top-1 -right-1 scale-75">
          •
        </Badge>
      );
    }
    
    return null;
  };

  return (
    <div 
      className="flex flex-col items-center justify-center p-3 sm:p-4 cursor-pointer group transition-all duration-200 hover:scale-105 active:scale-95"
      onClick={onClick}
    >
      <div className="relative">
        <div className="w-16 h-16 sm:w-20 sm:h-20 rounded-2xl overflow-hidden shadow-md group-hover:shadow-lg transition-shadow duration-200 bg-background border border-border/50">
          <img 
            src={app.icon} 
            alt={app.name}
            className="w-full h-full object-cover"
            onError={(e) => {
              const target = e.target as HTMLImageElement;
              target.style.display = 'none';
              const parent = target.parentElement!;
              parent.innerHTML = `<div class="w-full h-full flex items-center justify-center text-lg sm:text-2xl bg-muted">${app.name.charAt(0)}</div>`;
            }}
          />
        </div>
        {getStatusBadge()}
      </div>
      <div className="mt-2 text-center">
        <p className="text-xs sm:text-sm font-medium text-foreground leading-tight max-w-[88px] break-words">
          {app.name}
        </p>
      </div>
    </div>
  );
};